import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { stripLang } from "./i18n/LangContext";

export default function ScrollToTop() {
  const { pathname } = useLocation();
  // Sin el prefijo /en: cambiar de idioma no cuenta como cambiar de página
  const page = stripLang(pathname);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [page]);

  return null;
}
